import { DmsType } from "@domain/models/dms";
import { DmsDefaultSubType, DmsTaxeSubType, type DmsTypeOption, type TDmsTaxesOptions } from "@dms/types";
import { type GQL, Utils } from "@binale-tech/shared";

export const DmsTypeOptions: DmsTypeOption[] = Object.freeze([
    {
        value: DmsType.new_documents,
        translationKey: `app.titles.${DmsType.new_documents}`,
    },
    {
        value: DmsType.uncategorized,
        translationKey: `app.titles.${DmsType.uncategorized}`,
    },
    { isDivider: true },
    {
        value: DmsType.Deb,
        translationKey: `app.titles.${DmsType.Deb}`,
    },
    {
        value: DmsType.ER,
        translationKey: `app.titles.${DmsType.ER}`,
    },
    {
        value: DmsType.Bank,
        translationKey: `app.titles.${DmsType.Bank}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    {
        value: DmsType.KB,
        translationKey: `app.titles.${DmsType.KB}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    {
        value: DmsType.FE,
        translationKey: `app.titles.${DmsType.FE}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    {
        value: DmsType.POS,
        translationKey: `app.titles.${DmsType.POS}`,
    },
    {
        value: DmsType.LA,
        translationKey: `app.titles.${DmsType.LA}`,
    },
    { isDivider: true },
    {
        value: DmsType.taxes,
        translationKey: `app.titles.${DmsType.taxes}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    {
        value: DmsType.year_report,
        translationKey: `app.titles.${DmsType.year_report}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    {
        value: DmsType.contracts,
        translationKey: `app.titles.${DmsType.contracts}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    {
        value: DmsType.company,
        translationKey: `app.titles.${DmsType.company}`,
        isGroup: true,
        defaultSubtypes: [
            {
                value: DmsDefaultSubType.all_subTypes,
                translationKey: "app.components.all",
            },
            {
                value: DmsDefaultSubType.no_subTypes,
                translationKey: "app.titles.uncategorized",
            },
        ],
    },
    { isDivider: true },
    {
        value: DmsType.trash,
        translationKey: `app.titles.${DmsType.trash}`,
    },
]) as DmsTypeOption[];

export const isGroupType = (type: DmsType) => DmsTypeOptions.find((t) => t.value === type)?.isGroup;

export const DmsTaxesOptions: TDmsTaxesOptions[] = Object.freeze([
    {
        value: DmsTaxeSubType.vat,
        translationKey: `app.dms.${DmsTaxeSubType.vat}`,
    },
    {
        value: DmsTaxeSubType.corporation_tax,
        translationKey: `app.dms.${DmsTaxeSubType.corporation_tax}`,
    },
    {
        value: DmsTaxeSubType.business_tax,
        translationKey: `app.dms.${DmsTaxeSubType.business_tax}`,
    },
    {
        value: DmsTaxeSubType.statement,
        translationKey: `app.dms.${DmsTaxeSubType.statement}`,
    },
    {
        value: DmsTaxeSubType.income_tax,
        translationKey: `app.dms.${DmsTaxeSubType.income_tax}`,
    },
    {
        value: DmsTaxeSubType.other_taxes,
        translationKey: `app.dms.${DmsTaxeSubType.other_taxes}`,
    },
    {
        value: DmsTaxeSubType.tax_office,
        translationKey: `app.dms.${DmsTaxeSubType.tax_office}`,
    },
]) as TDmsTaxesOptions[];

export const necessaryFieldsForDocumentTypes: Readonly<
    Partial<Record<DmsType, readonly (keyof Partial<GQL.IDocumentUpdateInput>)[]>>
> = Utils.DmsDocumentRules.REQUIRED_FIELDS;

export const canBeZeroFields: readonly Partial<keyof GQL.IDocumentUpdateInput>[] = Object.freeze([
    "deadlineDays",
    "discountDays",
    "discountAmount",
    "discountPercent",
]);

export { DmsPaths } from "@domain/routing/dmsPaths";

export const ALL_DOCUMENTS = "all_documents";
